import React, { useEffect, useState } from "react";

import "./SupplierDashboard.scss";
import Chart from "../../common/Chart";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import {
  getEsgAggregate,
  getSupplierEmissionAggregate,
  getSupplierList,
  getSupplierStatusAggregate,
} from "../../../services/srmService";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import SupplierEmissionSources from "./SupplierEmissionSources";

export default function SupplierDashboard() {
  const { RangePicker } = DatePicker;
  let [show, setShow] = useState(false);
  let [esgData, setEsgData] = useState<any>({
    "Carbon Emissions (TCO2e)": 0,
    "Energy Consumed (GJ)": 0,
    "Water Consumed (KL)": 0,
    "Waste Generated (MT)": 0,
    // LTIFR: 0,
  });
  let [mainOptions, setMainOptions] = useState({
    chart: {
      toolbar: {
        show: false,
      },
      type: "line",
      stacked: false,
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#F5A710", "#59CE90"],
    series: [
      {
        name: "tCo2e Emissions",
        type: "column",
        data: [],
      },
      {
        name: "Carbon Intensity",
        type: "line",
        data: [],
      },
    ],
    stroke: {
      width: [4, 4],
    },
    plotOptions: {
      bar: {
        columnWidth: "20%",
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: [
      {
        seriesName: "tCo2e Emissions",
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
        },
        title: {
          text: "tCo2e",
        },
      },
      {
        opposite: true,
        seriesName: "Intensity",
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
        },
        title: {
          text: "Intensity",
        },
      },
    ],
    legend: {
      horizontalAlign: "center",
    },
  });

  let [carbonOptions, setCarbonOptions] = useState(
    JSON.parse(JSON.stringify(mainOptions))
  );
  let [energyOptions, setEnergyOptions] = useState(
    JSON.parse(JSON.stringify(mainOptions))
  );

  let [waterOptions, setWaterOptions] = useState(
    JSON.parse(JSON.stringify(mainOptions))
  );

  let [wasteOptions, setWasteOptions] = useState(
    JSON.parse(JSON.stringify(mainOptions))
  );

  let [safetyOptions, setSafetyOptions] = useState(
    JSON.parse(JSON.stringify(mainOptions))
  );
  let [supplierSummary, setSupplierSummary] = useState<any>({
    "Total created": 0,
    Active: 0,
    Inactive: 0,
    Registered: 0,
    "Registration pending": 0,
  });
  let [supplierList, setSupplierList] = useState<any>([]);
  let [currentSupplier, setCurrentSupplier] = useState(0);

  const getSupplierEsgAggregate = (from: any, to: any) => {
    let data = {
      from: from,
      to: to,
    };
    getEsgAggregate(data).then((res) => {
      // console.log(res.data);
      esgData["Carbon Emissions (TCO2e)"] =
        res.data["Absolute Carbon emission"] || "no data";
      esgData["Energy Consumed (GJ)"] =
        res.data["Energy Footprint"] || "no data";
      esgData["Water Consumed (KL)"] =
        res.data[
          "Total Water Consumption (Fresh Water Consumption + Water Recycled / Re-used)"
        ] || "no data";
      esgData["Waste Generated (MT)"] =
        res.data["Total waste Generated"] || "no data";
      if (
        res.data["Total Manhours worked"] !== undefined &&
        res.data["No of Lost Time Incidents (LTIs)"] !== undefined
      ) {
        // esgData["LTIFR"] = (
        //   (res.data["No of Lost Time Incidents (LTIs)"] * 100000) /
        //   res.data["Total Manhours worked"]
        // ).toFixed(2);
      } else {
        // esgData["LTIFR"] = "no data";
      }
      setEsgData({ ...esgData });
    });
  };

  const handleRangeChange = (e: any) => {
    getSupplierEsgAggregate(e[0].$y, e[1].$y);
  };
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const setUnits = () => {
    energyOptions.yaxis[0].seriesName = "Energy Footprint (GJ)";
    energyOptions.yaxis[0].title.text = "Energy Footprint (GJ)";
    energyOptions.yaxis[1].seriesName = "Energy Intensity";
    energyOptions.yaxis[1].title.text = "Energy Intensity";
    energyOptions.series[0].name = "Energy Footprint (GJ)";
    energyOptions.series[1].name = "Energy Intensity";
    setEnergyOptions(JSON.parse(JSON.stringify(energyOptions)));
    waterOptions.yaxis[0].seriesName = "Total water consumed (KL)";
    waterOptions.yaxis[0].title.text = "Total water consumed (KL)";
    waterOptions.yaxis[1].seriesName = "Water Intensity";
    waterOptions.yaxis[1].title.text = "Water Intensity";
    waterOptions.series[0].name = "Total water consumed (KL)";
    waterOptions.series[1].name = "Water Intensity";
    setWaterOptions(JSON.parse(JSON.stringify(waterOptions)));
    wasteOptions.yaxis[0].seriesName = "Total waste generated (MT)";
    wasteOptions.yaxis[0].title.text = "Total waste generated (MT)";
    wasteOptions.yaxis[1].seriesName = "Waste Intensity";
    wasteOptions.yaxis[1].title.text = "Waste Intensity";
    wasteOptions.series[0].name = "Total waste generated (MT)";
    wasteOptions.series[1].name = "Waste Intensity";
    setWasteOptions(JSON.parse(JSON.stringify(wasteOptions)));
    safetyOptions.yaxis[0].seriesName = "No of Lost Time Incidents (LTIs)";
    safetyOptions.yaxis[0].title.text = "No of Lost Time Incidents (LTIs)";
    safetyOptions.yaxis[1].seriesName = "Lost Time Frequency Rate (LTIFR)";
    safetyOptions.yaxis[1].title.text = "Lost Time Frequency Rate (LTIFR)";
    safetyOptions.series[0].name = "No of Lost Time Incidents (LTIs)";
    safetyOptions.series[1].name = "Lost Time Frequency Rate (LTIFR)";
    setSafetyOptions(JSON.parse(JSON.stringify(safetyOptions)));
  };

  useEffect(() => {
    setUnits();
    getSupplierStatusAggregate().then((res) => {
      supplierSummary = {
        "Total created": res.data.total,
        Active: res.data.active,
        Inactive: res.data.inactive,
        Registered: res.data.registered,
        "Registration pending": res.data.unregistered,
      };
      setSupplierSummary(supplierSummary);
    });
    getSupplierList(0, 1000, "").then((res) => {
      let registeredActiveSuppliers = res.data.filter(
        (item: any) => item.activationDate
      );
      setSupplierList(registeredActiveSuppliers);
      setCurrentSupplier(registeredActiveSuppliers[0].company);
    });
  }, []);

  useEffect(() => {
    if (currentSupplier) {
      getSupplierEsgAggregate(
        new Date().getFullYear(),
        new Date().getFullYear()
      );
      fetchAndSetEmissionAggregate();
    }
  }, [currentSupplier]);

  const fetchAndSetEmissionAggregate = () => {
    getSupplierEmissionAggregate(
      currentSupplier,
      "year",
      emissionAggregateYear
    ).then((res) => {
      let fillAxis = new Array(12).fill(0);
      let totalProduction = res.data["Total Production"];
      let key = "period";
      if (res.data["Absolute Carbon emission"]) {
        carbonOptions.series[0].data = [...fillAxis];
        carbonOptions.series[1].data = [...fillAxis];

        months.forEach((period: string, periodIndex: number) => {
          res.data["Absolute Carbon emission"].forEach((record: any) => {
            if (record[key] == period.toString()) {
              let production = totalProduction.find(
                (t: any) => t[key] == record[key]
              );
              carbonOptions.series[0].data[periodIndex] = record.total;
              carbonOptions.series[1].data[periodIndex] = Number(
                (record.total / production.total).toFixed(2)
              );
            }
          });
        });
      } else {
        carbonOptions.series[0].data = [];
        carbonOptions.series[1].data = [];
      }
      setCarbonOptions(JSON.parse(JSON.stringify(carbonOptions)));
      if (res.data["Energy Footprint"]) {
        energyOptions.series[0].data = [...fillAxis];
        energyOptions.series[1].data = [...fillAxis];
        months.forEach((period: string, periodIndex: number) => {
          res.data["Energy Footprint"].forEach((record: any) => {
            if (record[key] == period.toString()) {
              let production = totalProduction.find(
                (t: any) => t[key] == record[key]
              );
              energyOptions.series[0].data[periodIndex] = record.total;
              energyOptions.series[1].data[periodIndex] = Number(
                (record.total / production.total).toFixed(2)
              );
            }
          });
        });
      } else {
        energyOptions.series[0].data = [];
        energyOptions.series[1].data = [];
      }
      setEnergyOptions(JSON.parse(JSON.stringify(energyOptions)));
      if (res.data["Fresh Water Consumption (Sum of Input Water)"]) {
        waterOptions.series[0].data = [...fillAxis];
        waterOptions.series[1].data = [...fillAxis];
        months.forEach((period: string, periodIndex: number) => {
          res.data["Fresh Water Consumption (Sum of Input Water)"].forEach(
            (record: any) => {
              if (record[key] == period.toString()) {
                let production = totalProduction.find(
                  (t: any) => t[key] == record[key]
                );
                waterOptions.series[0].data[periodIndex] = record.total;
                waterOptions.series[1].data[periodIndex] = Number(
                  (record.total / production.total).toFixed(2)
                );
              }
            }
          );
        });
      } else {
        waterOptions.series[0].data = [];
        waterOptions.series[1].data = [];
      }
      setWaterOptions(JSON.parse(JSON.stringify(waterOptions)));
      if (res.data["Total waste Generated"]) {
        wasteOptions.series[0].data = [...fillAxis];
        wasteOptions.series[1].data = [...fillAxis];
        wasteOptions.xaxis.categories.forEach(
          (period: number, periodIndex: number) => {
            res.data["Total waste Generated"].forEach((record: any) => {
              if (record[key] == period.toString()) {
                let production = totalProduction.find(
                  (t: any) => t[key] == record[key]
                );
                wasteOptions.series[0].data[periodIndex] = record.total;
                wasteOptions.series[1].data[periodIndex] = Number(
                  (record.total / production.total).toFixed(2)
                );
              }
            });
          }
        );
      } else {
        wasteOptions.series[0].data = [];
        wasteOptions.series[1].data = [];
      }
      setWasteOptions(JSON.parse(JSON.stringify(wasteOptions)));
      if (
        res.data["No of Lost Time Incidents (LTIs)"] &&
        res.data["Total Manhours worked"]
      ) {
        safetyOptions.series[0].data = [...fillAxis];
        safetyOptions.series[1].data = [...fillAxis];
        safetyOptions.xaxis.categories.forEach(
          (period: string, periodIndex: number) => {
            res.data["No of Lost Time Incidents (LTIs)"].forEach(
              (record: any) => {
                res.data["Total Manhours worked"].forEach((record1: any) => {
                  if (record[key] == record1[key]) {
                    if (record[key] == period.toString()) {
                      safetyOptions.series[0].data[periodIndex] = record.total;
                      safetyOptions.series[1].data[periodIndex] = Number(
                        ((record.total * 1000000) / record1.total).toFixed(2)
                      );
                    }
                  }
                });
              }
            );
          }
        );
      } else {
        safetyOptions.series[0].data = [];
        safetyOptions.series[1].data = [];
      }
      setSafetyOptions(JSON.parse(JSON.stringify(safetyOptions)));
      setShow(false);
      setTimeout(() => {
        setShow(true);
      }, 300);
    });
  };

  const [emissionAggregateYear, setEmissionAggregateYear] = useState(
    new Date().getFullYear()
  );

  const handleEmissionYearChange = (e: any) => {
    setEmissionAggregateYear(e.$y);
  };

  useEffect(() => {
    fetchAndSetEmissionAggregate();
  }, [emissionAggregateYear]);
  const handleSupplierChange = (e: any) => {
    setCurrentSupplier(e.target.value);
  };

  return (
    <>
      <Box sx={{ overflow: "auto", height: "80vh" }}>
        <div
          style={{
            padding: "20px",
            backgroundColor: "white",
            borderRadius: "10px",
          }}
        >
          <p className="text-xl">
            <b>Summary</b>
          </p>
          <br />
          <div className="flex flex-row gap-x-1">
            {Object.keys(supplierSummary).map((eachKey) => {
              return (
                <div
                  style={{
                    backgroundColor: "#F5F7FA",
                    borderRadius: "15px",
                    padding: "15px",
                    minWidth: "19%",
                    border: "2px solid #D9DFE8",
                  }}
                >
                  <p style={{ color: "#596981", fontSize: "0.9rem" }}>
                    {eachKey}
                  </p>
                  <br />
                  <p className="text-xl">
                    <b>{supplierSummary[eachKey]}</b>
                  </p>
                </div>
              );
            })}
          </div>
          {/* <div className="flex flex-row justify-between mt-5 mb-5">
            {Object.keys(supplierSummary).map((eachKey, index) => {
              return (<div className={`pw-container ${"bg-suppliers-" + (index + 1)}  p-5`}>
                <div className="text-sm pb-2">{eachKey}</div>
                <div className="text-lg font-bold">{supplierSummary[eachKey]}</div>
              </div>)
            })}
          </div> */}
        </div>
        <div
          style={{
            padding: "20px",
            backgroundColor: "white",
            borderRadius: "10px",
          }}
          className="mt-4"
        >
          <SupplierEmissionSources></SupplierEmissionSources>
        </div>
        {/* <div style={{ padding: "20px", backgroundColor: "white", borderRadius: "10px" }}>
      <p className="text-xl"><b>Supplier summary</b></p>
      <br />
      </div> */}

        <br />
        {/* <div className="pw-card">
      <p className="text-xl"><b>Data Requests Summary</b></p>
      <br />
    </div>
    <br /> */}
        {/* <div
          style={{
            padding: "30px",
            backgroundColor: "white",
            borderRadius: "10px",
          }}
        >
          <div className="flex flex-row justify-between items-center">
            <p className="pw-chart-title">Individual Supplier Emission Data</p>
            <div className="flex flex-row justify-between items-center gap-x-4">
              <DatePicker
                allowClear={false}
                disabledDate={(d) => !d || d.isAfter(dayjs())}
                onChange={handleEmissionYearChange}
                defaultValue={dayjs()}
                picker="year"
              />
              <FormControl variant="standard" style={{ width: "150px" }}>
                <Select value={currentSupplier} onChange={handleSupplierChange}>
                  {supplierList.map((supplier: any) => {
                    return (
                      <MenuItem value={supplier.company}>
                        {supplier.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
          </div>
          {show ? (
            <div
              style={{ display: "flex", flexWrap: "wrap", marginTop: "10px" }}
            >
              <div className="pw-chart-box">
                <p className="pw-chart-title">Carbon Emissions</p>
                {carbonOptions.series[0].data.length ? (
                  <Chart
                    options={carbonOptions}
                    series={carbonOptions.series}
                  />
                ) : (
                  <div
                    style={{ height: "200px" }}
                    className="flex flex-row justify-center items-center"
                  >
                    No Data
                  </div>
                )}
              </div>
              <div className="pw-chart-box" style={{ borderLeft: "0px" }}>
                <p className="pw-chart-title">Energy Consumption</p>
                {energyOptions.series[0].data.length ? (
                  <Chart
                    options={energyOptions}
                    series={energyOptions.series}
                  />
                ) : (
                  <div
                    style={{ height: "200px" }}
                    className="flex flex-row justify-center items-center"
                  >
                    No Data
                  </div>
                )}
              </div>
              <div className="pw-chart-box" style={{ borderTop: "0px" }}>
                <p className="pw-chart-title">Water Consumption</p>
                {waterOptions.series[0].data.length ? (
                  <Chart options={waterOptions} series={waterOptions.series} />
                ) : (
                  <div
                    style={{ height: "200px" }}
                    className="flex flex-row justify-center items-center"
                  >
                    No Data
                  </div>
                )}
              </div>
              <div
                className="pw-chart-box"
                style={{ borderLeft: "0px", borderTop: "0px" }}
              >
                <p className="pw-chart-title">Waste Consumption</p>
                {wasteOptions.series[0].data.length ? (
                  <Chart options={wasteOptions} series={wasteOptions.series} />
                ) : (
                  <div
                    style={{ height: "200px" }}
                    className="flex flex-row justify-center items-center"
                  >
                    No Data
                  </div>
                )}
              </div>
              <div className="pw-chart-box" style={{ borderTop: "0px" }}>
                <p className="pw-chart-title">Safety</p>
                {safetyOptions.series[0].data.length ? (
                  <Chart
                    options={safetyOptions}
                    series={safetyOptions.series}
                  />
                ) : (
                  <div
                    style={{ height: "200px" }}
                    className="flex flex-row justify-center items-center"
                  >
                    No Data
                  </div>
                )}
              </div>
            </div>
          ) : (
            ""
          )}
        </div> */}
        <br />
        {/* <div
          style={{
            padding: "20px",
            backgroundColor: "white",
            borderRadius: "10px",
          }}
        >
          <div className="flex flex-row justify-between">
            <p className="text-xl">
              <b>ESG Summary</b>
            </p>
            <RangePicker
              defaultValue={[dayjs(), dayjs()]}
              onChange={handleRangeChange}
              picker="year"
            />
          </div>
          <br />
          <div className="flex flex-row gap-x-1">
            {Object.keys(esgData).map((key) => {
              return (
                <div
                  style={{
                    backgroundColor: "#F5F7FA",
                    borderRadius: "15px",
                    minWidth: "19%",
                    padding: "15px",
                    border: "2px solid #D9DFE8",
                  }}
                >
                  <p style={{ color: "#596981", fontSize: "0.9rem" }}>{key}</p>
                  <br />
                  <p className="text-xl">
                    <b>{esgData[key]}</b>
                  </p>
                </div>
              );
            })}
          </div>
        </div> */}
      </Box>
    </>
  );
}
